module.exports = __webpack_public_path__ + "img/takeda-logo.a2b4ff91.png";